import { useMemo } from "react"
import { get } from "lodash"
import { useModelMetadata } from "resources/models"
import { OK, combineTanStackStatuses } from "helpers/data-statuses"
import { useShouldAdjustDates } from "hooks/should-adjust-dates"
import { getComparisonEndDate, getComparisonStartDateUniversal } from "helpers/comparison-dates"
import { getDatesAdjusted, ONE_YEAR } from "helpers/dates"
import { useQueryStringState } from "./query-string"
import { useLastRouterMatchProp } from "./router"

export default function useAdjustedDates(modelId, earliestDate, latestDate, positionSet) {
  const [{ period: queryPeriod, startDate: queryStartDate, endDate: queryEndDate }] = useQueryStringState()
  const [modelMetadata, modelMetadataStatus] = useModelMetadata(modelId)
  const isPerformance = useLastRouterMatchProp("isPerformance", false)
  const [shouldAdjustDates, shouldAdjustDatesStatus] = useShouldAdjustDates(positionSet, earliestDate, isPerformance)

  return useMemo(() => {
    const combinedStatus = combineTanStackStatuses([modelMetadataStatus, shouldAdjustDatesStatus])

    if (combinedStatus !== OK) {
      return [combinedStatus, {}]
    }

    const unmodeledDates = get(modelMetadata, "availability.unmodeledDates", [])
    let computedPeriod = queryPeriod || ONE_YEAR
    if (queryStartDate) {
      computedPeriod = { startDate: queryStartDate, endDate: queryEndDate }
    }

    const adjustedStartDate = getComparisonStartDateUniversal(computedPeriod, latestDate, earliestDate, shouldAdjustDates, unmodeledDates)
    const adjustedEndDate = getComparisonEndDate(computedPeriod, latestDate)
    const datesAdjusted = getDatesAdjusted(computedPeriod, adjustedStartDate, adjustedEndDate, latestDate)

    return [OK, {
      period: computedPeriod,
      adjustedStartDate,
      adjustedEndDate,
      datesAdjusted,
    }]
  }, [modelMetadataStatus, modelMetadata, queryStartDate, queryEndDate, queryPeriod, latestDate, earliestDate, shouldAdjustDates, shouldAdjustDatesStatus])
}
